import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Paper } from "@mui/material";
import Moment from "react-moment";
import { setAlert } from "../../../action/alert";
import Alert from "../../layout/Alert";
import DataTable from "../../Common/DataTable/DataTable";
import EmptyState from "../../Common/EmptyState/EmptyState";

const DeviceConnDisconnLogs = ({
  deviceDetails,
  getDeviceConnDisconnLogsData,
  connectionStatusLogs,
}) => {
  const [deviceConnDisconnLogsData, setDeviceConnDisconnLogsData] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const headers = {
    serialNumber: "S.No",
    onlineStatus: "Status",
    timestamp: "Timestamp",
  };
  const columns = Object.keys(headers).map((key) => ({
    key,
    label: headers[key],
    minWidth: key === "timestamp" ? 220 : 160,
    align: key === "timestamp" ? "right" : "left",
    justifyContent: key === "timestamp" ? "flex-end" : "flex-start",
    headerCellSx: {
      fontWeight: 600,
      backgroundColor: "background.paper",
      whiteSpace: "nowrap",
    },
    render: (value, row) => {
      const cellValue = key === "serialNumber" ? row.serialNumber : value;
      const strVal = String(cellValue ?? "");

      if (key === "timestamp") {
        return strVal && strVal.length > 0 ? (
          <Box className={strVal.length > 60 ? "breakWord" : ""}>
            <Moment format="DD-MM-YYYY HH:mm:ss" date={value} />
          </Box>
        ) : (
          ""
        );
      }

      if (key === "onlineStatus") {
        return (
          <Box
            component="span"
            sx={{
              color: value === true ? "green" : "red",
              fontWeight: "bold",
              wordBreak: "break-all",
            }}
          >
            {value === true ? "Online" : "Offline"}
          </Box>
        );
      }

      return (
        <Box className={strVal.length > 60 ? "breakWord" : ""}>
          {cellValue || ""}
        </Box>
      );
    },
  }));

  useEffect(() => {
    if (
      deviceDetails &&
      deviceDetails instanceof Object &&
      deviceDetails.hasOwnProperty("deviceId")
    ) {
      setIsLoading(true);
      getDeviceConnDisconnLogsData(deviceDetails?.deviceId ?? "", () => {
        setIsLoading(false);
      });
    }
  }, [deviceDetails, getDeviceConnDisconnLogsData]);

  useEffect(() => {
    setDeviceConnDisconnLogsData(connectionStatusLogs);
  }, [connectionStatusLogs]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          minHeight: "40vh",
          mt: 2,
          mb: 2,
          py: 2,
        }}
      >
        <CircularProgress size={60} sx={{ color: "#AFB42B" }} />
      </Box>
    );
  }
  const connDisconnRows = deviceConnDisconnLogsData.map((element, index) => ({
    ...element,
    rowId: `${element?.timestamp || "conn"}-${index}`,
    serialNumber: index + 1,
  }));
  const hasConnDisconnData = Array.isArray(connDisconnRows) && connDisconnRows.length > 0;

  return (
    <Box sx={{ width: "100%", minWidth: 0, mt: 2, mb: 2 }}>
      <Alert />
      <Paper
        sx={{
          p: 2,
          boxShadow: 2,
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        {!hasConnDisconnData ? (
          <EmptyState
            message="No Data found"
            sx={{ bgcolor: "transparent", p: 0 }}
          />
        ) : (
          <DataTable
            columns={columns}
            data={connDisconnRows}
            rowKey="rowId"
            minWidth="100%"
            maxHeight="58vh"
            striped={false}
            hoverEffect={false}
            tableContainerSx={{ boxShadow: "none", borderRadius: 0, width: "100%", minWidth: 0 }}
            msgForDisplay="No Data found"
            sx={{ scrollBehavior: "auto" }}
          />
        )}
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setCustomAlert: (message, alertType) =>
    dispatch(setAlert(message, alertType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceConnDisconnLogs);
